<template>
    <div>
        <h1>Choose a measure</h1>

        <div
            v-if="measures.length > 0"
            class="question-holder"
        >
            <ul>
                <li
                    v-for="measure in measures"
                    :key="measure.ID"
                >
                    <label>
                        <input
                            v-model="chosenMeasure"
                            type="radio"
                            name="kappa"
                            :value="measure.ID"
                        >
                        {{ measure.Name }}
                    </label>
                </li>
            </ul>
        </div>

        <span v-else>Geen measures (inloggen?)</span>
        <button
            v-show="!!chosenMeasure"
            @click="$store.dispatch('assessment/start')"
        >
            STARTEN
        </button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'ChooseMeasure',
    data() {
        return {
            //
        };
    },
    computed: {
        ...mapGetters('auth', {
            isAuthenticated: 'isAuthenticated',
        }),
        ...mapState('measures', {
            measures: 'measures',
        }),
        chosenMeasure: {
            get() {
                return this.$store.state.measures.measure.ID;
            },
            set(value) {
                this.$store.commit(
                    'measures/SELECT_MEASURE',
                    this.measures.find((measure) => measure.ID === value),
                );
            },
        },
    },
    watch: {
        isAuthenticated: {
            immediate: true,
            handler(newValue) {
                if (newValue === false) {
                    return;
                }

                this.$store.dispatch('measures/fetch');
            },
        },
    },
};
</script>

<style>
ul {
  list-style: none;
}

li {
  text-align: left;
}

button {
  font-size: 24px;
}

.question-holder {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
